<template>
    <g :id="data.id" class="transform" :transform="matrix">
        <g class="anchor" @mousedown.stop="handleClick">
            <template>
                <comp-video v-if="data.type === 'video'" :data="data"/>
                <comp-text v-if="data.type === 'text'" :data="data"/>
                <comp-image v-else-if="data.type === 'image'" :data="data"/>
            </template>
        </g>
    </g>
</template>

<script>
	export default {
		name: "Comp",
		props: {
			data: {},
			z: Number
		},
		computed: {
			matrix() {
				return `translate(${this.data.x}, ${this.data.y}) rotate(${this.data.rotate}, ${this.data.width / 2}, ${this.data.height / 2})`
			}
		},
		methods: {
			handleClick(e) {
				this.$store.dispatch('elm_click', {
					id: this.data.id,
					event: e
				})
			}
		}
	}
</script>

<style scoped>

</style>
